import { BaseEditor, IBaseEditorProps } from "./BaseEditor";
import * as React from "react";
import { isNotEmpty } from "./Validation/RawValueRules";
import { Guid } from "../Utils/Guid";
import * as classNames from "classNames";

export type IBaseTextBoxEditorProps = IBaseEditorProps;

export abstract class BaseTextBoxEditor<TProps extends IBaseTextBoxEditorProps> extends BaseEditor<TProps> {
    constructor(props: TProps) {
        super(props);
    }

    public render(): JSX.Element {
        const wrapperCss = classNames(this.props.isNotForm ? "" : "form-group", this.props.cssWrapper, {
            error: this.state.typingFinished && (!this.state.isValid || !this.state.isValidOutside),
            valid: this.state.typingFinished && this.state.isValid && this.state.isValidOutside,
        });

        return (
            <div className={wrapperCss} ref={(elem: HTMLElement) => (this.wrapperRef = elem)}>
                {this.getLabel()}

                {this.props.inputGridClasses && (
                    <div className="row">
                        <div className={this.props.inputGridClasses}>
                            <div className={classNames("controls-text")}>
                                {this.getInput()}
                                {this.getValidationErrorsContainer()}
                            </div>
                        </div>
                    </div>
                )}

                {!this.props.inputGridClasses && (
                <>
                    <div className={classNames("controls-text", "controls-wrap", this.props.cssControlTxt)}>
                        {this.getInput()}
                        
                    </div>
                    {this.getValidationErrorsContainer()}
                </>
                )}

                {this.getInfoText()}
            </div>
        );
    }

    public componentDidMount(): void {
        this.bindLabelToInput();
    }

    protected abstract getInput(): JSX.Element;

    private getLabel(): JSX.Element {
        if (!this.props.label) {
            return null;
        }

        if (this.props.labelGridClasses) {
            return (
                <div className="row">
                    <div className={this.props.labelGridClasses}>
                        <div className="control-label">
                            <label htmlFor={this.state.inputGroupId}>{this.props.label}</label>
                            {this.getTooltip()}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="control-label">
                <label htmlFor={this.state.inputGroupId}>{this.props.label}</label>
                {this.getTooltip()}
            </div>
        );
    }

    private bindLabelToInput(): void {
        let propId: string = null;
        if (this.props.hasOwnProperty("id")) {
            // tslint:disable-next-line
            propId = this.props["id"];
        }

        const id = isNotEmpty(propId) ? propId : Guid.getNext();
        this.setState({ inputGroupId: id });
    }
}
